/* eslint-disable @angular-eslint/no-output-on-prefix */
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Form } from './form-helpers/form';
import { IFormModel } from './form.model';
import { InputType } from './input-type.enum';

@Component({
  selector: 'app-form',
  templateUrl: './form.component.html',
})
export class FormComponent<T> extends Form<T> implements OnInit {
  @Input() inputs?: Array<IFormModel>;
  @Input() prefix?: string = '';
  @Input() showButtons?: boolean = true;
  @Input() showTitle?: boolean = true;
  @Input() title?: string;
  @Input() isLoading: boolean = false;
  @Input() submitButtonText: string = 'submit';
  @Input() cancelButtonText: string = 'cancel';

  @Output() onSubmit = new EventEmitter<any>();
  @Output() onCancel = new EventEmitter<any>();
  @Output() valueChange: EventEmitter<any> = new EventEmitter<any>();

  public inputType: typeof InputType = InputType;

  constructor() {
    super();
  }

  ngOnInit(): void {
    if (this.prefix) {
      this.setTranslationPrefix(this.prefix!);
    }
    this.registerComponents(this.inputs!);
  }

  checkIfValid(): boolean {
    this.trigger();
    return this.canTrySubmit;
  }

  checkIfValidWithDisabledControls(): boolean {
    this.trigger();
    return this.canTrySubmitWithDisabledControls;
  }

  stepperButtonClicked(): boolean {
    this.trigger();
    console.log(
      'phone control valid:',
      this.formGroup?.controls['phoneNumber']?.valid,
    );
    console.log(
      'phone control errors:',
      this.formGroup?.controls['phoneNumber']?.errors,
    );
    console.log('form valid:', this.formGroup?.valid);
    return this.canTrySubmit;
  }

  submitButtonClicked(): void {
    this.trigger();
    if (this.canTrySubmit) {
      this.onSubmit.emit(this.getFormObject());
    }
  }

  cancelButton(): void {
    this.onCancel.emit();
  }

  getMinDate(minDate: Date | undefined) {
    return minDate ? minDate : undefined;
  }

  getMaxDate(maxDate: Date | undefined) {
    return maxDate ? maxDate : undefined;
  }

  checkFunction(rowFunction: any, value?: any): any {
    if (rowFunction) {
      return rowFunction(value);
    }
    return null;
  }

  emitValue(value: any): void {
    this.valueChange.emit(value);
  }

  onChange(value: string): void {
    this.valueChange.emit(value);
  }
}
